export const SELECT_SHARE = "SELECT_SHARE";
export const SELECT_ITEM = "SELECT_ITEM";
export const INVALIDATE_SHARE = "INVALIDATE_SHARE";
export const REQUEST_ITEM = "REQUEST_ITEM";
export const RECEIVE_SHARE = "RECEIVE_SHARE";
export const UNLOCK_SHARE = 'UNLOCK_SHARE';
export const WRONG_PASSWORD = "WRONG_PASSWORD";
export const DECODE_TEXT = 'DECODE_TEXT';
export const COPY_SHARE = 'COPY_SHARE';
export const SET_SHARE_ACCESS = 'SET_SHARE_ACCESS';
export const SET_SHARE_COPY_STATUS = 'SET_SHARE_COPY_STATUS';
export const RECEIVE_COPY_SHARE_RESULT = 'RECEIVE_COPY_SHARE_RESULT';
export const RECIEVE_COPY_SHARE_JOB_DONE = 'RECIEVE_COPY_SHARE_JOB_DONE';
export const NETWORK_ERROR = 'NETWORK_ERROR';
export const UPDATE_SHARE = 'UPDATE_SHARE';
export const DELETE_SHARE = 'DELETE_SHARE';
export const SET_SHARE_TITLE = 'SET_SHARE_TITLE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const MOVE_NOTE = 'MOVE_NOTE';
export const NOTE_MOVE_FAILED = 'NOTE_MOVE_FAILED';

export enum ShareCopyStatus {
  SHARE_COPY_INITIAL = 0,
  SHARE_COPY_IN_PROGRESS,
  SHARE_COPY_DONE
}

export function selectShare(id, securityKey, invalidate = false) {
  return {
    type: SELECT_SHARE,
    id,
    securityKey,
    invalidate
  };
}

export function selectItem(nodeId?, invalidate = false) {
  return {
    type: SELECT_ITEM,
    nodeId,
    invalidate
  };
}
export function invalidateShare() {
  return {
    type: INVALIDATE_SHARE
  };
}

export function unlockShare(password) {
  return {
    type: UNLOCK_SHARE,
    password
  };
}

export function recieveShare(result, fromClient) {
  return {
    type: RECEIVE_SHARE,
    result,
    fromClient,
  };
}

export function decodeText(globalId, text) {
  return {
    type: DECODE_TEXT,
    globalId,
    text
  };
}

export function copyShare() {
  return {
    type: COPY_SHARE
  };
}

export function setShareAccess(data) {
  return {
    type: SET_SHARE_ACCESS,
    data,
  };
}

export function setShareCopyStatus(status) {
  return {
    type: SET_SHARE_COPY_STATUS,
    status
  };
}

export function recieveCopyShareResult(result) {
  return {
    type: RECEIVE_COPY_SHARE_RESULT,
    result
  };
}

export function updateShare(share) {
  return {
    type: UPDATE_SHARE,
    share,
  }
}

export function recieveCopyShareJobDone() {
  return  {
    type: RECIEVE_COPY_SHARE_JOB_DONE
  };
}

export function networkError(code) {
  return {
    type: NETWORK_ERROR,
    code
  };
}

export function deleteShare() {
  return {
    type: DELETE_SHARE,
  };
}

export function setShareTitle(title) {
  return {
    type: SET_SHARE_TITLE,
    title,
  }
}

export function updateNote(noteId, note) {
  return  {
    type: UPDATE_NOTE,
    noteId,
    note,
  }
}

export function moveNote(noteId, currentWorkspaceId, workspaceIdToMove) {
  return {
    type: MOVE_NOTE,
    noteId,
    currentWorkspaceId,
    workspaceIdToMove
  }
}

export function noteMoveFailed() {
  return {
    type: NOTE_MOVE_FAILED,
  }
}
